import React from "react";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ checked, onChange, label }) => {
  return (
    <div className="toggle-container">
      {label && <span className="toggle-label">{label}</span>}
      
      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="slider" />
      </label>
    </div>
  );
};

export default ToggleSwitch;